export default "__VITE_ASSET__DFRmBOu1__"